import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-loop-post-type-filter-settings',
  styleUrls: ['./post-type-filter-settings.component.scss'],
  templateUrl: './post-type-filter-settings.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PostTypeFilterSettingsComponent implements OnInit {
  @Input() parentForm: FormGroup;
  filters: FormArray;

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.filters = this.parentForm.get('filters') as FormArray;
  }

  addFilter(event): void {
    event.preventDefault();
    this.filters.push(
      this.fb.group({
        label: ['', Validators.required],
        value: this.fb.group({
          id: ['', Validators.required],
          valuePath: ['', Validators.required],
        }),
        options: this.fb.array([]),
      }),
    );
  }

  removeFilter(event, index): void {
    event.preventDefault();
    this.filters.removeAt(index);
  }

  getOptionsForFilter(filterIndex: number): FormArray {
    return this.filters.at(filterIndex).get('options') as FormArray;
  }

  addOption(event, filterIndex): void {
    event.preventDefault();
    this.getOptionsForFilter(filterIndex).push(
      this.fb.group({
        id: ['', Validators.required],
        value: ['', Validators.required],
      }),
    );
  }

  removeOption(event, filterIndex, index): void {
    event.preventDefault();
    this.getOptionsForFilter(filterIndex).removeAt(index);
  }
}
